import { createContext } from 'react';
export var AccordionContext = createContext({});


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet/es6/components/Accordion/AccordionContext.js
// module id = 854
// module chunks = 1